<div class="row">
    <div class="col-sm-12" style="text-align: center;">
        <h3>{{titre}}</h3>
    </div>
</div>
<div class="col-md-12">
    <mat-divider></mat-divider>
  </div>
<form  [formGroup]="formulaireForm" (ngSubmit)="submit()">
    <div class="row">
        <div class="col-sm-2" style="text-align: center;">
            <p>Destinataire</p>
        </div>
        <div class="data-class  col-sm-8">
            <mat-form-field class="full-width">
                <mat-label>{{libelle}}</mat-label>
                <input matInput required name="destinataire" formControlName="email" />
                <mat-error *ngIf="formulaireForm.get('email').hasError('required')">
                    Destinataire est obligatoire
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-2" style="text-align: center;">
            <p>Objet de l'email</p>
        </div>
        <div class="data-class  col-sm-8">
            <mat-form-field class="full-width">
                <input matInput  name="objet" value='{{this.objetMail}}' formControlName="objetMail" />
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-2" style="text-align: center;">
            <p>Corps de l'email</p>
        </div>
        <div class="data-class  col-sm-8">
            <mat-form-field  class="full-width">
                <textarea  matInput  rows="20" name="corps"  value='{{this.corpsMail}}' formControlName="corpsMail"></textarea>
            </mat-form-field>
        </div>
    </div>

    <div class="col-sm-12 row" style="text-align: center;">
        <div class="col-sm-5 text-center" style="margin-top: 10px;">
            <button mat-raised-button color="default" type="button" (click)="onModalCancel()">
                Annuler
            </button>
        </div>
        <div class="col-sm-5 text-center" style="margin-top: 10px;">
            <button mat-raised-button color="primary" type="submit">
                Envoyer
            </button>
        </div>
    </div>
    
</form>